import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { IAttachment } from 'clickNgo/models/file'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

export const deleteAttachments = async (attachments: IAttachment[]) => {
  const source = CrudStore.get(CrudStoreItem.LegalAttachments)
  const promises = attachments.map((attachment) =>
    source.delete('672', { EntryId: attachment.entryId })
  )

  await Promise.all(promises).catch((error) => {
    Logger.error(error)
  })
}
